import React from "react";
import Badge from "../badge";

export interface ListDropdownProps {
  title: string;
  content: string;
  badge?: string;
  url?: string;
}

const Dropdown: React.FC<ListDropdownProps> = ({
  title,
  content,
  badge,
  url,
}) => {
  const handleClick = () => {
    if (url) window.open(url, "_blank");
  };

  return (
    <div
      className={`box-border content-stretch flex flex-col gap-3 items-start [&_*]:box-border w-full ${
        url ? "cursor-pointer" : ""
      }`}
      data-name="Dropdown"
      onClick={handleClick}
    >
      {/* Badge - responsive size */}
      <div className="w-full">
        <span className="block md:hidden">
          <Badge.Round size="md" type="secondary" style="fill" color="main">
            {badge}
          </Badge.Round>
        </span>
        <span className="hidden md:block">
          <Badge.Round size="lg" type="secondary" style="fill" color="main">
            {badge}
          </Badge.Round>
        </span>
      </div>
      {/* Content - responsive text */}
      <div className="content-stretch flex flex-col items-start w-full gap-1">
        <div className="flex flex-col justify-center leading-[0] relative shrink-0 w-full">
          <p
            className="font-bold text-[#212121] text-[14px] md:text-[16px] tracking-[-0.28px] md:tracking-[-0.32px] leading-[20px] md:leading-[24px] whitespace-nowrap overflow-hidden truncate"
            style={{ maxWidth: "100%" }}
            title={title}
          >
            {title}
          </p>
        </div>
        <p
          className="font-medium text-[#888888] text-[12px] md:text-[14px] leading-[16px] md:leading-[20px] tracking-[-0.24px] md:tracking-[-0.28px] w-full break-words overflow-hidden line-clamp-2"
          title={content}
        >
          {content}
        </p>
      </div>
    </div>
  );
};

export default Dropdown;
